import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {NgbModal, NgbModalConfig} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import {ToastrService} from 'ngx-toastr';
import {Role} from '../../interface/role';
import {Router} from '@angular/router';
import {ProfileService} from '../../services/profile.service';
import {RoleAddComponent} from "./role-add/role-add.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {

  public roles!: Role[];
  temp = [];
  selected = [];
  public closeResult: string;
  public getDismissReason: string;
  public isButtonVisible = false;

  public test = 0;
  rows = [];
  loadingIndicator = true;
  reorderable = true;
  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(config: NgbModalConfig,
              private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef,
              private toast: ToastrService, private translate: TranslateService,
              private profileService: ProfileService,
              private router: Router) {
    this.getRoleList();
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
  }

  getRoleList(): any {
    this.profileService.getCollection().subscribe({
      next: (res: any) => {
        this.roles = res['hydra:member'];

        console.log(res);

        // cache our list
        this.temp = [...res['hydra:member']];

        this.rows = this.roles;

        this.loadingIndicator = false;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        console.log('Error while fetching the records');
        this.loadingIndicator = false;
      }
    });
  }

  addRole(): void {

    const modalRef = this.modalService.open(RoleAddComponent, {
      // centered: true,
    });

    modalRef.result.then(() => {
      setTimeout(() => {
        this.loadingIndicator = true;
        this.changeDetectorRef.detectChanges();
        this.getRoleList();
      }, 5);
    });
  }

  editRole(data: any): void {
    console.log(data);
    const modalRef = this.modalService.open(RoleAddComponent,
        {
          // centered: true,
          // backdrop: 'static'
        }
    );
    modalRef.componentInstance.data = data;

    modalRef.result.then(() => {
      this.loadingIndicator = true;
      setTimeout(() => {
        this.changeDetectorRef.detectChanges();
        this.getRoleList();
      }, 5);
    });
  }

  settingRole(id: number): void {
    this.router.navigate(['/security/role/edit', id]);
  }

  onSelect({selected}): void {
    console.log('Select Event', selected, this.selected);
    console.log(this.selected);

    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    this.isButtonVisible = this.selected.length > 0;
  }

  onDetailToggle(event): void {
    console.log('Detail Toggled', event);
  }

  deleteRole(id: number): any {
    Swal.fire({
      title: this.translate.instant('are you sure?'),
      text: this.translate.instant('you won\'t be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, delete it!'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;
        this.profileService.delete(id).subscribe({
          next: (res) => {
            this.toast.success(this.translate.instant('profile') + ' ' + this.translate.instant('deleted') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getRoleList();
          },
          error: (res) => {
            this.loadingIndicator = false;
            this.toast.error(res['hydra:title'], 'Error');
          }
        });
      }
    });

  }

  remove(): void {
    this.selected = [];
  }

  deleteSelectedProfileRows(): void {
    Swal.fire({
      title: this.translate.instant('are you sure you want to delete ') + this.selected.length + this.translate.instant(' line(s) ?'),
      text: this.translate.instant('you won\'t be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('yes, delete it!'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.loadingIndicator = true;

        const obj = this.selected;
        const vals = Object.values(obj);
        const ids = vals.map(a => (a.id));
        this.profileService.deleteMultipleProfile(ids).subscribe({
          next: (res) => {
            console.log(res);
            this.toast.success(this.translate.instant('profile') + ' ' + this.translate.instant('deleted') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.getRoleList();
            this.remove();
            this.isButtonVisible = false;
          },
          error: (err: any) => {
            console.log(err);
          }
        });

      }
    });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    // tslint:disable-next-line:only-arrow-functions typedef
    const temp = this.temp.filter(function(d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

}
